// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"42d66c6e","453":"5d969051"}[chunkId] + ".chunk.js";
};